import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AverageBoxComponent } from './average-box.component';

@NgModule({
  declarations: [AverageBoxComponent],
  imports: [CommonModule],
  exports: [AverageBoxComponent],
})
export class AverageBoxModule {}
